// Enum describing the type of payment method
export enum PaymentCardType {
  Visa = 'Visa',
  MasterCard = 'MasterCard',
  AmericanExpress = 'AmericanExpress',
  Other = 'Other',
}
